import React from 'react';
import type { DimensionId } from '../../types/investmentPhilosophy';
import { DIMENSION_LABELS } from '../../config/investmentArchetypes';

interface IPDimensionBarProps {
  dimension: DimensionId;
  value: number;
}

export const IPDimensionBar: React.FC<IPDimensionBarProps> = ({ dimension, value }) => {
  const labels = DIMENSION_LABELS[dimension];
  // Clamp and map [-2, +2] to [0, 100]
  const clamped = Math.max(-2, Math.min(2, value));
  const leftPct = ((clamped + 2) / 4) * 100;

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-1.5">
        <span
          className="font-mono text-xs uppercase tracking-wider"
          style={{ color: 'hsl(var(--muted-foreground))' }}
        >
          {labels.negative}
        </span>
        <span
          className="font-mono text-xs uppercase tracking-wider"
          style={{ color: 'hsl(var(--muted-foreground))' }}
        >
          {labels.positive}
        </span>
      </div>
      <div className="relative h-2 rounded-full" style={{ backgroundColor: 'var(--clue-border-light)' }}>
        <div
          className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-4 h-4 rounded-full"
          style={{
            left: `${leftPct}%`,
            backgroundColor: 'var(--clue-green-accent)',
            boxShadow: 'var(--clue-shadow-sm)',
          }}
          aria-label={`${value.toFixed(1)} on ${labels.negative} to ${labels.positive} scale`}
        />
      </div>
      <div className="mt-1 text-right">
        <span
          className="font-mono text-[10px]"
          style={{ color: 'hsl(var(--muted-foreground))' }}
        >
          {value >= 0 ? '+' : ''}
          {value.toFixed(1)}
        </span>
      </div>
    </div>
  );
};
